export const PLANS = [
    {
        id: 'standard',
        nameKey: 'plans.standard.name',
        subtitleKey: 'plans.standard.subtitle',
        currencyKey: 'plans.standard.currency',
        price: 1,
        buttonLabelKey: 'plans.button',
        popular: false,
        popularKey: 'plans.popular',
    },
    {
        id: 'complete',
        nameKey: 'plans.complete.name',
        subtitleKey: 'plans.complete.subtitle',
        currencyKey: 'plans.complete.currency',
        price: 2,
        buttonLabelKey: 'plans.button',
        popular: true,
        popularKey: 'plans.popular',
        // repeats the car photo from the landing preview page inside this plan's column
        showsVehiclePhoto: true,
    },
];

export const FEATURE_SECTIONS = [
    {
        titleKey: 'sections.main.title',
        features: [
            { labelKey: 'features.serviceHistory', standard: true, complete: true },
            { labelKey: 'features.serviceVisits', standard: true, complete: true },
            { labelKey: 'features.recalls', standard: true, complete: true },
            { labelKey: 'features.insuranceCases', standard: true, complete: true },
            { labelKey: 'features.officialRepairs', standard: true, complete: true },
            { labelKey: 'features.mileage', standard: true, complete: true },
            { labelKey: 'features.factoryEquipment', standard: true, complete: true },
            { labelKey: 'features.engineNumber', standard: true, complete: true },
        ],
    },
    {
        titleKey: 'sections.advanced.title',
        features: [
            { labelKey: 'features.closedDatabases', standard: false, complete: true },
            { labelKey: 'features.auctionData', standard: false, complete: true },
            { labelKey: 'features.saleHistory', standard: false, complete: true },
            { labelKey: 'features.damageDetails', standard: false, complete: true },
            { labelKey: 'features.salePhotos', standard: false, complete: true },
        ],
    },
];

export const PAGE_TITLE_KEY = 'page.title';
export const PAGE_SUBTITLE_KEY = 'page.subtitle';
export const SELECTED_LABEL_KEY = 'plans.selected';

export const TYPE_MAP = {
    external: 'standard',
    internal: 'standard',
    combined: 'complete',
};

// plan id -> job type sent to the API. 'external' is the plan the external-only flow (VIN not in the internal DB)
// picks itself. Standard is always an external (dealer PDF) order, even for a VIN in the internal DB: internal data is
// sold only as part of Complete (SC-QA-13). Never map a plan to 'internal'; the API turns it into external
export const PLAIN_TO_ENUM = {
    standard: 'external',
    complete: 'combined',
    external: 'external',
};

// Where "view existing report" lands for the plan being ordered: the page for the job type that plan creates
export const existingReportPath = (plan, vin, jobUuid) =>
    PLAIN_TO_ENUM[plan] === 'combined' ? `/combined-report/${vin}/${jobUuid}` : `/report/${jobUuid}`;
